import { Radio } from "./radio.js";
import { RadioStyles, RadioTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
/**
 * The Fabric Radio component.
 *
 * @public
 */
export const definition = Radio.compose({
    name: `${DesignSystem.prefix}-radio`,
    template: RadioTemplate,
    styles: RadioStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=radio.definition.js.map